import moment from "moment-msdate";

import IFormulaBase from "./formulaBase";
import {makeDisplayMvtsLink, setApiURL} from "@taskpane/utils";
import { standardDateFormat } from "@taskpane/types";
import { Endpoints } from "../core/endpoints";

export interface GLRangeFormulaData {
  companyName: string;
  fiscalYear: string;
  fromAccount: string;
  toAccount: string;
  currency: string;
  fromDate: string;
  toDate: string;
  withZeroAccounts: string;
  withOpeningBalance: string;
  withMvts: string;
  originalCurrency: string;
  debits: string;
  credits: string;
}

export default class GLRangeFormula implements IFormulaBase {
  constructor(private token: string | null) {}
  private name = "PMGLRange";
  formulaData: GLRangeFormulaData;

  generate() {
    const data = this.formulaData;
    return `#${this.name}/${data.companyName}/${data.fiscalYear}/${data.fromAccount}/${data.toAccount}/{${data.fromDate}}/{${data.toDate}}/${data.currency}/${data.withOpeningBalance}/${data.withMvts}/${data.originalCurrency}/${data.debits}/${data.credits}`;
  }

  async getAmount(): Promise<number | string> {
    const data = this.formulaData;
    return await fetch(setApiURL(Endpoints.getTrialBalance(data.companyName, data.fiscalYear)) + "?" + new URLSearchParams({
      from_date: data.fromDate,
      to_date: data.toDate,
      from_account: data.fromAccount,
      to_account: data.toAccount,
      currency_code: data.currency,
      //with_zero_accounts: data.withZeroAccounts ? "true" : "false",
      with_movements: data.withMvts ? "true" : "false",
      with_initial_balance: data.withOpeningBalance ? "true" : "false",
      with_original_currency: data.originalCurrency ? "true" : "false",
      with_provisional_entries: true ? "true" : "false",
      debits: data.debits ? "true" : "false",
      credits: data.credits ? "true" : "false",
    }).toString(), { method: 'GET', headers: { 'X-Apikey': this.token } }).then((response) => {
      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      };
      return response.json();
    });
  }

  parse(value: string): IFormulaBase {
    if (!isNaN(<any>value)) return null;
    if (!value) return null;
    if (!value.startsWith("#" + this.name)) return null;
    const formulaInst = new GLRangeFormula(this.token);
    let tvalue = value;
    let match = tvalue.match(/\{[0-9,/-]*\}/);

    while (match && match.length > 0) {
      const concatValue = match[0]
        .substring(1, match[0].length - 1);

      tvalue =
        tvalue.substring(0, tvalue.indexOf(match[0])) +
        (!isNaN(<any>concatValue) ? concatValue :
          concatValue.replace(/\//g, "dateSep")
          .replace(",", ".")) +
        tvalue.substring(tvalue.indexOf(match[0]) + match[0].length);
      match = tvalue.match(/\{[0-9,/-]*\}/);
    }

    const values = tvalue.split("/");
    const dateFromString = !isNaN(<any>values[5]) ? values[5] : values[5].replace(/dateSep/g, "/");
    const dateToString = !isNaN(<any>values[6]) ? values[6] : values[6].replace(/dateSep/g, "/");

    formulaInst.formulaData = {
      companyName: values[1],
      fiscalYear: values[2],
      fromAccount: values[3],
      toAccount: values[4],
      fromDate: !isNaN(<any>dateFromString) ? moment.fromOADate(dateFromString).format(standardDateFormat) : dateFromString,
      toDate: !isNaN(<any>dateToString) ? moment.fromOADate(dateToString).format(standardDateFormat) : dateToString,
      currency: values[7],
      withZeroAccounts: "true",
      withOpeningBalance: values[8].toLowerCase().trim(),
      withMvts: values[9].toLowerCase().trim(),
      originalCurrency: values[10].toLowerCase().trim(),
      debits: values.length > 11 ? values[11].toLowerCase().trim() : "true",
      credits: values.length > 12 ? values[12].toLowerCase().trim() : "true",
    };
    return formulaInst;
  }

  getDisplayMvtsLink(): string {
    return makeDisplayMvtsLink(this.formulaData.companyName,
      this.formulaData.fromDate,
      this.formulaData.toDate,
      this.formulaData.fromAccount,
      this.formulaData.toAccount,
      this.formulaData.currency,
      this.formulaData.withZeroAccounts === 'true',
      this.formulaData.withOpeningBalance === 'true',
      this.formulaData.withMvts === 'true',
      true,
      this.formulaData.debits === 'true',
      this.formulaData.credits === 'true');
  }

  async getMvts() {
    const data = this.formulaData;
    const result = await fetch(setApiURL(Endpoints.getTrialBalanceMvts(data.companyName, data.fiscalYear)) + "?" + new URLSearchParams({
      from_date: data.fromDate,
      to_date: data.toDate,
      from_account: data.fromAccount,
      to_account: data.toAccount,
      currency_code: data.currency,
      //with_zero_accounts: withZeroAccounts ? "true" : "false",
      with_movements: data.withMvts ? "true" : "false",
      with_initial_balance: data.withOpeningBalance ? "true" : "false",
      with_provisional_entries: true ? "true" : "false",
      debits: data.debits ? "true" : "false",
      credits: data.credits ? "true" : "false",
    }).toString(), { method: 'GET', headers: { 'X-Apikey': this.token } }).then((response) => {
      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      };
      return response.json();
    });
    return result;
  }
}
